"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const spectacle_ui_game_bridge_1 = require("spectacle-ui-game-bridge");
// Default to a gameBridge instance that does not show errors so the default usage is simpler
const gameBridge = (0, spectacle_ui_game_bridge_1.createGameBridge)(false);
const GameBridgeContext = (0, react_1.createContext)(gameBridge);
exports.default = GameBridgeContext;
